import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GuestAppEventParams} from '../../views/ExperiencesPage/types';

const initialState: GuestAppEventParams = {
  dealName: '',
  housingId: '',
  isUser: false,
  reservationId: '',
};

const guestAppEventParamsSlice = createSlice({
  name: 'guestAppEventParams',
  initialState,
  reducers: {
    setHousingId(state, action: PayloadAction<string>) {
      state.housingId = action.payload;
    },
    setDealName(state, action: PayloadAction<string>) {
      state.dealName = action.payload;
    },
    setReservationId(state, action: PayloadAction<string>) {
      state.reservationId = action.payload;
    },
    setIsUser(state, action: PayloadAction<boolean>) {
      state.isUser = action.payload;
    },
  },
});

export const {setHousingId, setDealName, setReservationId, setIsUser} =
  guestAppEventParamsSlice.actions;

export default guestAppEventParamsSlice.reducer;
